import React, { useState } from 'react';
import PeriodForm from './PeriodForm';
import { FaChartLine, FaSyncAlt, FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { createPeriod } from 'redux/erp/periodSlice';

const PeriodHeader = ({ refreshGrid, addRow }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const handleNewPeriod = () => setOpen(true);

  const handleSave = async (data) => {
    try {
      const result = await dispatch(createPeriod(data)).unwrap();
      toast.success('Period created successfully');
      addRow(result.data.attributes);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <div className="tw-mb-3">
        <div className="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-3">
          <div className="tw-flex tw-items-center tw-gap-3">
            <div className="tw-w-1.5 tw-h-10 tw-rounded-sm tw-flex-shrink-0" style={{ background: 'linear-gradient(to bottom, #0ea5e9, #6366f1)' }} />
            <div className="tw-flex tw-items-center tw-gap-2">
              <FaChartLine className="tw-text-blue-600" size={20} />
              <div>
                <h1 className="tw-mb-0 tw-font-bold tw-text-2xl tw-text-gray-900">Periods</h1>
                <p className="tw-text-gray-500 tw-text-sm tw-mb-0">Periods control whether inventory transactions are open or closed for adjustment.</p>
              </div>
            </div>
          </div>

          <div className="tw-flex tw-items-center tw-gap-2">
            <button
              type="button"
              onClick={handleNewPeriod}
              className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-sm tw-border tw-border-blue-600 tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700 tw-text-sm tw-font-medium tw-cursor-pointer"
            >
              <FaPlus size={11} /> New Period
            </button>
            <button
              type="button"
              onClick={refreshGrid}
              className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-sm tw-border tw-border-slate-300 tw-bg-white tw-text-slate-600 hover:tw-bg-slate-50 tw-text-sm tw-cursor-pointer"
            >
              <FaSyncAlt size={12} /> Reload
            </button>
          </div>
        </div>
      </div>

      {open && (
        <PeriodForm
          open={open}
          setOpen={setOpen}
          record={null}
          title="New Period"
          onSave={handleSave}
        />
      )}
    </>
  );
};

PeriodHeader.propTypes = {
  refreshGrid: PropTypes.func.isRequired,
  clearFilter: PropTypes.func,
  addRow: PropTypes.func.isRequired
};

export default PeriodHeader;
